import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "input-amount-box" }
const _hoisted_3 = { class: "input-amount-box" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "button-box" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "video-dic" }
const _hoisted_9 = { class: "video-item" }
const _hoisted_10 = { class: "game-map-list" }
const _hoisted_11 = { class: "game-map-item" }
const _hoisted_12 = {
  key: 0,
  class: "dou zhuang"
}
const _hoisted_13 = {
  key: 1,
  class: "dou xian"
}
const _hoisted_14 = {
  key: 2,
  class: "dou he"
}
const _hoisted_15 = { class: "user-list" }
const _hoisted_16 = { class: "user-item" }
const _hoisted_17 = { class: "left" }
const _hoisted_18 = { class: "block-box" }
const _hoisted_19 = { class: "black-list" }
const _hoisted_20 = { class: "black-item" }
const _hoisted_21 = { class: "left" }
const _hoisted_22 = { class: "bottom-box" }

import virtual_blacklist from "@/ts/dbvo/virtual_blacklist";
import SignalRClient from "@/ts/SignalRClient";
import Tools from "@/ts/Tools";
import KillPigConfigVO from "@/ts/VO/KillPigConfigVO";
import OutPutStopService from "@/ts/VO/OutPutStopService";
import RoomVO from "@/ts/VO/RoomVO";
import { computed } from "@vue/reactivity";
import {
  createDiscreteApi,
  NAlert,
  NButton,
  NCard,
  NForm,
  NFormItem,
  NInput,
  NInputNumber,
  NSlider,
  NSwitch,
  NTabPane,
  NTabs,
  NTag,
  NVirtualList,
  useMessage,
} from "naive-ui";
import { onMounted, ref } from "vue";

type OutPutGetAllBlockList = {
  flag: boolean;
  errorMessage: string;
  list: virtual_blacklist[];
};

type OutPutMessage = {
  flag: boolean;
  errorMessage: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const api = createDiscreteApi(["message"]);

const show_add_black_box = ref(false);
/**
 * 是否显示余额框
 */
const show_amount_box = ref<boolean>(false);
const set_amount = ref<number>();
const dealer_name = ref<string>();

//#region 受控房间

const roomList = ref<RoomVO[]>([]);
const userList = ref<any[]>([]);
const blockList = ref<virtual_blacklist[]>([]);

const selectUser = ref<any>({});

const selectRooms = ref<(string | number)[]>([]);

//#endregion

//#region 对局面板
const currentRoom = ref<string | number>();
const selectRoomOptions = computed(() => {
  const dlist: {
    label: string;
    value: string;
  }[] = [];
  if (selectRooms.value != null) {
    for (let i = 0; i < selectRooms.value!.length; i++) {
      const vd = selectRooms.value[i];
      for (let k = 0; k < roomList.value.length; k++) {
        const kd = roomList.value[k];
        if (kd.RoomNumber == vd) {
          dlist.push({
            label: kd.label,
            value: kd.value,
          });
          break;
        }
      }
    }
  }
  return dlist;
});

/**
 * 当前选择的房间对象
 */
const selectRoomVo = computed(() => {
  const room = roomList.value.find((x) => x.RoomNumber == currentRoom.value);
  return room;
});

const maps = computed(() => {
  const list = selectRoomVo.value?.VirtualMapsDecoding?.map((x) => x);
  return list ?? [];
});

//日志列表
const logs = ref<
  {
    key: string;
    value: string;
  }[]
>([]);
for (let i = 0; i < 1000; i++) {
  logs.value!.push({
    key: `测试${i}`,
    value: "成功连接到服务器",
  });
}

//#endregion

// const marks = ref({
//   34: '太棒了',
//   75: '不错'
// });
// const markValue = ref([50, 70]);

const input = ref<KillPigConfigVO>(new KillPigConfigVO());

async function InitAsync() {
  /**
   * 获取杀猪配置
   */
  GetKillPigConfig();
  GetUserListAsync();
  GetAllBlockListAsync();

  var respRoomObj = await SignalRClient.Instance.InvokeAsync<{
    [key: string]: RoomVO;
  }>("GetRoomList");
  for (const key in respRoomObj) {
    const room = respRoomObj[key];
    Object.setPrototypeOf(room, RoomVO.prototype);
    if (room.OpenKillPig) {
      selectRooms.value?.push(room.RoomNumber);
    }
    roomList.value.push(room);
  }
}

/**
 * 获取用户列表
 */
async function GetUserListAsync() {
  Tools.FetchGetAsync<{
    allcount: number;
    pagecount: number;
    data: any;
  }>("Game/GetUserList", {
    page: 1,
    pageSize: 100,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      userList.value = resp.Data?.data;
    }
  });
}

/**
 * 获取黑名单列表
 */
async function GetAllBlockListAsync() {
  var blockListItem =
    await SignalRClient.Instance.InvokeAsync<OutPutGetAllBlockList>(
      "GetAllBlockList"
    );
  if (blockListItem.flag) {
    blockList.value = blockListItem.list;
  }
}

/**
 * 添加黑名单
 */
function AddBlackList() {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>(
    "AddBlockList",
    dealer_name.value
  ).then((resp) => {
    if (!resp.flag) {
      Tools.AlertError(resp.errorMessage);
    } else {
      Tools.AlertSuccess("添加成功!");
      GetAllBlockListAsync();
    }
  });
}

/**
 * 删除黑名单
 */
function DeleteBlack(id: number) {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>(
    "RemoveBlockFromID",
    id
  ).then((resp) => {
    if (!resp.flag) {
      Tools.AlertError(resp.errorMessage);
    } else {
      Tools.AlertSuccess("删除成功!");
      GetAllBlockListAsync();
    }
  });
}

/**
 * 尝试添加黑名单
 */
function TryAddBlockList() {
  dealer_name.value = "";
  show_add_black_box.value = true;
}

/**
 * 设置勾选启用
 */
async function SetKillPigAsync() {
  var roomlist = selectRooms.value;
  var flag = await SignalRClient.Instance.InvokeAsync<boolean>(
    "SetKillPig",
    roomlist
  );
  if (flag) {
    api.message.success("设置成功");
  } else {
    api.message.error("设置失败");
  }
}

async function GetRoomDataAsync() {
  const roomNumber = currentRoom.value;
  let gameType: string = "";
  let gameCode: string = "";
  if (roomNumber != null && roomNumber != "") {
    let arr = `${roomNumber}`.split("-");
    gameType = arr[0];
    gameCode = arr[1];
  } else {
    return;
  }
  let room = await SignalRClient.Instance.InvokeAsync<RoomVO>(
    "GetRoomData",
    gameType,
    gameCode
  );
  if (room) {
    Object.setPrototypeOf(room, RoomVO.prototype);
    for (let i = 0; i < roomList.value.length; i++) {
      const v = roomList.value[i];
      if (v.RoomNumber == room.RoomNumber) {
        roomList.value[i] = room;
        debugger;
        break;
      }
    }
  }
}

/**
 * 获取杀猪配置
 */
function GetKillPigConfig() {
  SignalRClient.Instance.InvokeAsync<KillPigConfigVO>("GetKillPigConfig").then(
    (x) => {
      input.value = x;
    }
  );
}

function AddBlack() {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>("GetKillPigConfig").then(
    (v) => {
      if (!v.flag) {
        Tools.AlertError(v.errorMessage);
        return;
      }
      Tools.AlertSuccess("添加成功!");
      GetAllBlockListAsync();
    }
  );
}

function CancelBlack() {
  show_add_black_box.value = false;
}

/**
 * 充值服务
 */
function RestartService() {
  SignalRClient.Instance.InvokeAsync<OutPutStopService>("RestartService").then(
    (x) => {
      if (x.Ok) {
        Tools.AlertSuccess("重启服务命令已成功发送,等待10秒后，重新尝试登录!");
      }
      else {
        Tools.AlertError(x.ErrorMessage);
      }
    }
  );
}

/**
 * 设置杀猪配置
 * @param config
 */
function SetKillPigConfig() {
  SignalRClient.Instance.InvokeAsync<KillPigConfigVO>(
    "SetKillPigConfig",
    input.value
  ).then((x) => {
    if (x) {
      api.message.success("设置成功!");
    } else {
      api.message.error("设置失败!");
    }
  });
}

/**
 * 显示设置金额
 * @param v
 */
function ShowSetAmount(v: any) {
  selectUser.value = v;
  //显示窗口
  set_amount.value = undefined;
  show_amount_box.value = true;
}

/**
 * 确认充值
 */
function SubmitSetAmount() {
  Tools.FetchGetAsync("Game/SetUserAmountFromUserName", {
    userName: selectUser.value.userName,
    amount: set_amount.value,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess("设置成功!");
      GetUserListAsync();
    }
  });
}

/**
 * 取消
 */
function CancelSetAmount() { }

setInterval(GetRoomDataAsync, 2000);

InitAsync();

return (_ctx: any,_cache: any) => {
  const _component_n_modal = _resolveComponent("n-modal")!
  const _component_n_transfer = _resolveComponent("n-transfer")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_popconfirm = _resolveComponent("n-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_modal, {
      show: show_add_black_box.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show_add_black_box).value = $event)),
      preset: "dialog",
      title: "请添加黑名单",
      "positive-text": "确认",
      "negative-text": "取消",
      onPositiveClick: AddBlackList,
      onNegativeClick: CancelBlack
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(NInput), {
            value: dealer_name.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dealer_name).value = $event)),
            placeholder: "请输入荷官名称"
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_n_modal, {
      show: show_amount_box.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((show_amount_box).value = $event)),
      preset: "dialog",
      title: "设置账号余额",
      "positive-text": "确认",
      "negative-text": "取消",
      onPositiveClick: SubmitSetAmount,
      onNegativeClick: CancelSetAmount
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, "账号: " + _toDisplayString(selectUser.value.userName), 1),
            _createElementVNode("span", null, "当前余额:" + _toDisplayString(selectUser.value.credit), 1)
          ]),
          _createVNode(_unref(NInputNumber), {
            value: set_amount.value,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((set_amount).value = $event)),
            placeholder: "请输入要增加或减少的额度"
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(NCard), {
      class: "card-box",
      title: "SASS系统"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NTabs), {
          style: { height: '100%' },
          "pane-class": "tab-pane-box",
          size: "small",
          type: "line",
          animated: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NTabPane), {
              name: "1",
              tab: "全局设置"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NForm), {
                  class: "form-box",
                  "label-placement": "left",
                  "label-width": "auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NFormItem), { label: "头部保留局" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInputNumber), {
                          value: input.value.HeaderReserveJuNumber,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((input.value.HeaderReserveJuNumber) = $event)),
                          "show-button": false,
                          max: 1000,
                          min: 0
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), { label: "搜索索引" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInputNumber), {
                          value: input.value.SearchStartIndex,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((input.value.SearchStartIndex) = $event)),
                          "show-button": false,
                          max: 1000,
                          min: 0
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), { label: "忽略局" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInputNumber), {
                          value: input.value.IgnoreJuNumber,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((input.value.IgnoreJuNumber) = $event)),
                          "show-button": false,
                          max: 1000,
                          min: 1
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), { label: "尾部保留局" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInputNumber), {
                          value: input.value.EndReserveJuNumber,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((input.value.EndReserveJuNumber) = $event)),
                          "show-button": false,
                          max: 1000,
                          min: 2
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), { label: "最低启动金额" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInputNumber), {
                          value: input.value.KillStartAmount,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((input.value.KillStartAmount) = $event)),
                          "show-button": false,
                          min: 0
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(NButton), {
                    class: "seting-btn",
                    type: "success",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (SetKillPigConfig()))
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("设置")
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(NTabPane), {
              name: "2",
              tab: "受控房间"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_transfer, {
                  value: selectRooms.value,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((selectRooms).value = $event)),
                  options: roomList.value,
                  "source-filterable": ""
                }, null, 8, ["value", "options"]),
                _createVNode(_unref(NButton), {
                  type: "info",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (SetKillPigAsync()))
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("设置勾选启用")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(NTabPane), {
              style: {"display":"flex","flex-direction":"column"},
              name: "3",
              tab: "对局面板"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_select, {
                  class: "select-room",
                  value: currentRoom.value,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((currentRoom).value = $event)),
                  options: _unref(selectRoomOptions)
                }, null, 8, ["value", "options"]),
                _createVNode(_component_n_space, {
                  style: {"display":"flex","flex-direction":"column","flex-grow":"1"},
                  vertical: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_space, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_unref(NTag), { type: "success" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 房间号:" + _toDisplayString(_unref(selectRoomVo)?.RoomNumber), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NTag), { type: "success" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 当前局号:" + _toDisplayString(_unref(selectRoomVo)?.VirtualJuNumber) + " " + _toDisplayString(_unref(selectRoomVo)?.VirtualChildJuNumber), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NTag), { type: "success" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 游戏状态:" + _toDisplayString(_unref(selectRoomVo)?.VirtualST), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NTag), { type: "success" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 荷官:" + _toDisplayString(_unref(selectRoomVo)?.VirtualDealer), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_unref(NTag), { type: "warning" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 游戏包索引:" + _toDisplayString(_unref(selectRoomVo)?.NextIndex) + "/" + _toDisplayString(_unref(selectRoomVo)?.CacheGameInfoCount), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NTag), { type: "warning" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 锚点:" + _toDisplayString(_unref(selectRoomVo)?.GameInfoStatusPointCount) + "个 ", 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectRoomVo)?.VideoDataDic, (v, k) => {
                              return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_unref(NTag), { type: "info" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("视频" + _toDisplayString(v.VideoName) + "索引", 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_unref(NTag), { type: "error" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(v.CurrentIndex) + "/" + _toDisplayString(v.AllIndexCount), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            }), 256))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(maps), (v) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (v == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "庄"))
                        : (v == 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "闲"))
                          : (v == 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "和"))
                            : _createCommentVNode("", true)
                    ]))
                  }), 256))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(NTabPane), {
              name: "4",
              tab: "账号充值"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (v) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", null, "账号:" + _toDisplayString(v.userName), 1),
                        _createElementVNode("span", null, [
                          _cache[15] || (_cache[15] = _createTextVNode("余额: ")),
                          _createVNode(_unref(NTag), { type: "warning" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(v?.credit ?? 0), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _createVNode(_unref(NButton), {
                        class: "set-amount-btn",
                        onClick: ($event: any) => (ShowSetAmount(v))
                      }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode("设置余额")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 256))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(NTabPane), {
              name: "5",
              tab: "黑名单"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockList.value, (v) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", null, "荷官:" + _toDisplayString(v.dealer_name), 1)
                        ]),
                        _createVNode(_component_n_popconfirm, {
                          onPositiveClick: ($event: any) => (DeleteBlack(v.id!))
                        }, {
                          trigger: _withCtx(() => [
                            _createVNode(_unref(NButton), { type: "error" }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("删除")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" 您确定要删除 “" + _toDisplayString(v.dealer_name) + "” 吗? ", 1)
                          ]),
                          _: 2
                        }, 1032, ["onPositiveClick"])
                      ]))
                    }), 256))
                  ]),
                  _createVNode(_unref(NButton), {
                    class: "black-button",
                    type: "primary",
                    onClick: TryAddBlockList
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("添加黑名单")
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_n_popconfirm, { onPositiveClick: RestartService }, {
        trigger: _withCtx(() => [
          _createVNode(_unref(NButton), {
            style: {"width":"100%"},
            type: "error"
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode("重启服务")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _cache[20] || (_cache[20] = _createTextVNode(" 重启服务后,需大概等待10秒，在尝试登录! "))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})